import { render, staticRenderFns } from "./choose-person.vue?vue&type=template&id=5c1efca1&"
import script from "./choose-person.vue?vue&type=script&lang=js&"
export * from "./choose-person.vue?vue&type=script&lang=js&"
import style0 from "./choose-person.vue?vue&type=style&index=0&id=5c1efca1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports